import Vue from 'vue';

import MaxBoard from "./version1.1/MixBoard"   //混合键盘 可改变版本

import NumBoard from "./version1.1/NumBoard"  //数字键盘

import WordBoard from "./version1.1/WordBoard" //文字键盘

import LetterBoard from "./version1.1/LetterBoard" //字母键盘


const $mixBoard = Vue.extend(MaxBoard),

      $numBoard = Vue.extend(NumBoard),

      $wordBoard = Vue.extend(WordBoard),

      $letterBoard = Vue.extend(LetterBoard);

//挂载节点
let $maxBoardNode,
    $numBoardNode,
    $wordBoardNode,
    $letterBoardNode;


$mixBoard.newInstance = (option)=>{

    if($maxBoardNode)document.body.removeChild($maxBoardNode);


    let $visible =JSON.parse(JSON.stringify(option.$data.visible));
    option.$data.visible = false;

    let instance = new $mixBoard({

        data:option.$data,
        methods:option.$methods

    }).$mount();

    $maxBoardNode = instance.$el;
    document.body.appendChild(instance.$el);

    Vue.nextTick(()=>{
        instance.visible = $visible
    });

    return instance;

}

$numBoard.newInstance = (option)=>{

    if($numBoardNode)document.body.removeChild($numBoardNode);

    let $visible =JSON.parse(JSON.stringify(option.$data.visible));
    option.$data.visible = false;

    let instance = new $numBoard({
        data:option.$data,
        methods:option.$methods
    }).$mount();

    $numBoardNode = instance.$el;
    document.body.appendChild(instance.$el);

    Vue.nextTick(()=>{
        instance.visible = $visible
    })

    return instance;
}


$wordBoard.newInstance = (option)=>{

    if($wordBoardNode)document.body.removeChild($wordBoardNode);

    let $visible =JSON.parse(JSON.stringify(option.$data.visible));
    option.$data.visible = false;

    let instance = new $wordBoard({
        data:option.$data,
        methods:option.$methods
    }).$mount();

    $wordBoardNode = instance.$el;
    document.body.appendChild(instance.$el);

    Vue.nextTick(()=>{
        instance.visible = $visible
    })

    return instance;
}

$letterBoard.newInstance = (option)=>{

    if($letterBoardNode)document.body.removeChild($letterBoardNode);

    let $visible =JSON.parse(JSON.stringify(option.$data.visible));
    option.$data.visible = false;

    let instance = new $letterBoard({
        data:option.$data,
        methods:option.$methods
    }).$mount();

    $letterBoardNode = instance.$el;
    document.body.appendChild(instance.$el);

    Vue.nextTick(()=>{
        instance.visible = $visible
    })
    return instance;
}


export default {
    mixBoard:$mixBoard.newInstance,
    numBoard:$numBoard.newInstance,
    wordBoard:$wordBoard.newInstance,
    letterBoard:$letterBoard.newInstance
}
